// Framework and third-party non-UI
import React from 'react';

// Redux, contexts, and local helpers/utils/modules

// Component specific modules (Component-styled, etc.)

// App components

// Third-party components (buttons, icons, etc.)
import {
  CalciteOption,
  CalciteSelect,
  CalciteSelectWrapperProps
} from 'components/Calcite';

type CalciteOptionInstance = React.ReactElement<
  React.ComponentProps<typeof CalciteOption>
>;

interface SelectProps
  extends Omit<CalciteSelectWrapperProps, 'children' | 'value'> {
  options: Array<CalciteOptionInstance>;
  value: string | boolean | undefined;
}

const PLACEHOLDER_VALUE = '__PLACEHOLDER__';

const isPlaceholderValue = (value: any) =>
  value === '' || value === undefined || value === null;

const Select: React.FC<SelectProps> = ({ options, ...rest }) => {
  const renderPlaceholder = () => {
    if (isPlaceholderValue(rest.selectedOption)) {
      return [
        <CalciteOption
          disabled
          key={PLACEHOLDER_VALUE}
          value={PLACEHOLDER_VALUE}
          selected
        >
          Select...
        </CalciteOption>
      ];
    } else {
      return [];
    }
  };

  return (
    <CalciteSelect
      {...rest}
      value={isPlaceholderValue(rest.value) ? PLACEHOLDER_VALUE : rest.value!}
    >
      {[...renderPlaceholder(), ...options]}
    </CalciteSelect>
  );
};

export default Select;
